import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from 'react-auth-kit';
import PageLoader from '../modules/shared/components/PageLoader';

const LessonAuthWrapper = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    // Check authentication status
    const checkAuth = () => {
      if (!isAuthenticated()) {
        // Store the current lesson URL for redirect after login
        const currentUrl = location.pathname + location.search;
        console.log('LessonAuthWrapper - Storing redirect URL:', currentUrl);
        localStorage.setItem('redirectAfterLogin', currentUrl);
        
        // Also add as URL parameter as fallback
        const loginUrl = `/login?redirect=${encodeURIComponent(currentUrl)}`;
        console.log('LessonAuthWrapper - Redirecting to:', loginUrl);
        
        // Redirect to login with URL parameter
        navigate(loginUrl);
        return;
      }
    };

    // Small delay to ensure proper initialization
    const timeoutId = setTimeout(checkAuth, 50);
    
    return () => clearTimeout(timeoutId);
  }, [isAuthenticated, location, navigate]);

  // Show loader while checking authentication
  if (!isAuthenticated()) {
    return <PageLoader />;
  }

  // User is authenticated, render the lesson component
  return children;
};

export default LessonAuthWrapper;
